import { render, staticRenderFns } from "./AlternativeBlock.vue?vue&type=template&id=35450a2f&"
import script from "./AlternativeBlock.vue?vue&type=script&lang=ts&"
export * from "./AlternativeBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AlternativeBlock.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports